<script lang="ts">
    export let value: number;
    export let maxValue: number;
    export let selected = false;
    export let hovered = false;
</script>

<button class="star-button"
        class:hovered={hovered}
        aria-label="Hodnocení {value} z {maxValue}"
        on:click
        on:mouseenter
        on:mouseleave>

    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g clip-path="url(#rating-star-slip)">
            {#if selected}
                <path class="star-path"
                      d="M19.4673 23.3152L12.0003 17.8272L4.53326 23.3152L7.40026 14.4522L-0.0627441 8.99916H9.15126L12.0003 0.121155L14.8493 8.99916H24.0623L16.6003 14.4522L19.4673 23.3152Z"/>
            {:else}
                <path class="star-path"
                      d="M19.4673 23.3152L12.0003 17.8272L4.53326 23.3152L7.40026 14.4522L-0.0627441 8.99916H9.15126L12.0003 0.121155L14.8493 8.99916H24.0623L16.6003 14.4522L19.4673 23.3152ZM12.0003 15.3452L15.6583 18.0342L14.2583 13.6902L17.9373 10.9992H13.3903L12.0003 6.66815L10.6103 10.9992H6.06226L9.74526 13.6902L8.34526 18.0342L12.0003 15.3452Z"/>
            {/if}
        </g>

        <defs>
            <clipPath id="rating-star-slip">
                <rect width="24" height="24" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</button>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .star-button {
        display: flex;
        outline: 2px solid transparent;
        border: none;
        cursor: pointer;
        padding: 3px;
        background-color: transparent;
        border-radius: @border-radius-base;
        transition: background-color 0.3s ease-in-out, outline-color 0.3s ease-in-out, transform 0.3s ease-in-out;

        .star-path {
            fill: @text-color;
            transition: fill 0.3s ease-in-out;
        }

        &:hover {
            background-color: @table-bg-hover;
            outline-color: var(--accent-blue-new);
        }

        &.hovered {
            transform: translateY(-2px);

            .star-path {
                fill: var(--accent-blue-new);
            }
        }
    }
</style>